<template>
  <SimpleDataWithVariation
    :title="title"
    :item-id="itemId"
    :value="value"
    :variation="variation"
    :raw-variation="rawVariation"
    :request-status="requestStatus"
    :comparation-value="comparationValue"
    v-bind="$attrs"
    @reload="getData"
  />
</template>

<script>
import proprietaryModel from '@/mixins/proprietary-model';
import SimpleDataWithVariation from '@/components/cards/models/SimpleDataWithVariation';
import { mapActions } from 'vuex';
import EventBus from '@/utils/event-bus';

export default {
  name: 'PropUserFrequency',
  components: {
    SimpleDataWithVariation,
  },
  mixins: [
    proprietaryModel,
  ],
  props: {
    title: {
      type: String,
      required: true,
    },
    itemId: {
      type: [String, Number],
      required: true,
    },
  },
  data() {
    return {
      requestStatus: 'loading',
      value: '',
      variation: '',
      rawVariation: '',
      comparationValue: '',
    };
  },
  created() {
    this.getData();
  },
  methods: {
    ...mapActions('cards', [
      'getWarroomService',
    ]),
    getData(options) {
      if (!options?.silentRefresh) {
        this.requestStatus = 'loading';
      }

      this.getWarroomService({
        itemId: this.itemId,
        servicePath: 'getMonitoringOverviewWithVariation',
      })
        .then(response => {
          const {
            total_users,
            total_users_variation,
            collected_mentions,
            previous_collected_mentions,
            previous_total_users,
            previous_total_users_variation,
            previous_displaced_collected_mentions,
          } = response;

          const {
            value,
            variation,
          } = this.getFrequency({
            total: total_users,
            totalVariation: total_users_variation,
            mentions: collected_mentions,
            previousMentions: previous_collected_mentions,
          });

          const previous_value = this.getFrequency({
            total: previous_total_users,
            totalVariation: previous_total_users_variation,
            mentions: previous_collected_mentions,
            previousMentions: previous_displaced_collected_mentions,
          }).value || 0;

          this.value = `${value.toFixed(2)}`;
          this.variation = variation;
          this.rawVariation = variation;
          this.comparationValue = previous_value;
          this.requestStatus = 'success';

          if (options?.silentRefresh) {
            EventBus.$emit('updated', { itemId: this.itemId });
          }
        })
        .catch(error => {
          console.error(error);
          this.requestStatus = 'error';
        });
    },
    getFrequency({ total, totalVariation, mentions, previousMentions }) {
      const previous_total_users = parseInt(total / ((1 + totalVariation) / 100), 10);
      const userFrequency = mentions / total;
      const previousUserFrequency = previousMentions / previous_total_users;
      const userFrequencyVariation = previousUserFrequency !== 0
        ? ((userFrequency / previousUserFrequency) - 1) * 100
        : (userFrequency > 0 ? 100 : 0);

      return {
        value: userFrequency,
        variation: userFrequencyVariation,
      };
    },
  },
};
</script>

